import assignIn from 'lodash/assignIn'
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'
import isArray from 'lodash/isArray'
import size from 'lodash/size'
import isEqual from 'lodash/isEqual'

class Form {
  constructor (values) {
    this.$errors = {}
    this.$busy = false
    this.$originalData = cloneDeep(values)
    assignIn(this, values)
  }

  /**
   * Returns the values based on original fields
   *
   * @returns {Object}
   */
  $data () {
    let data = cloneDeep(this.$originalData)
    each(this.$originalData, (_, key) => {
      data[key] = this[key]
    })

    return data
  }

  /**
   * Returns the data value as a FormData
   */
  $asFormData () {
    let formData = new FormData()

    each(this.$data(), (_, key) => {
      if (isArray(_)) {
        each(_, item => {
          formData.append(`${key}[]`, item)
        })
      } else if (_ !== null && _ !== undefined) {
        formData.append(key, _)
      }
    })

    return formData
  }

  /**
   * Reset the form to its original phase
   * Set the original data values
   * Clear errors
   */
  $reset () {
    assignIn(this, this.$originalData)
    this.$clearErrors()
  }

  /**
   * Set the form errors
   * @param {Oject, Array} errors
   */
  $setErrors (errors) {
    this.$errors = errors
  }

  /**
   * Set the form error
   */
  $setError (field, errors) {
    this.$errors = {
      ...this.$errors
    }

    this.$errors[field] = errors
  }

  /**
   * Clear all form errors
   */
  $clearErrors () {
    this.$errors = {}
  }

  /**
   * Clear the errors in a specific field
   *
   * @param {String} field
   */
  $clearError (field) {
    delete this.$errors[field]
  }

  /**
   * Check if the field has error
   *
   * @param {String} field
   * @returns {Boolean}
   */
  $hasError (field) {
    return !!this.$errors[field]
  }

  /**
   * Check if there are any errors
   */
  $hasErrors () {
    return size(this.$errors) !== 0
  }

  /**
   * Get the error description of a specific field
   *
   * @param {String} field
   * @returns {String}
   */
  $getError (field) {
    return this.$errors[field]
  }

  /**
   * Get the error description of a specific field
   *
   * @param {String} field
   * @returns {String}
   */
  $getErrors () {
    return this.$errors
  }

  /**
   * Check if the data has changed
   *
   * @returns {Boolean}
   */
  $isDirty () {
    let hasChanges = false
    each(this.$originalData, (_, key) => {
      if (!isEqual(this[key], this.$originalData[key])) {
        hasChanges = true
        return false
      }
    })
    return hasChanges
  }
}

export default Form
